(function(){
  if (window.__mhCarouselInit) return;
  window.__mhCarouselInit = true;

  function initCarousels(scope) {
    // Carousel behaviour moved to the site-wide, event-delegated
    // assets/mh-card-carousel.js (loaded from theme.liquid). Per-node binding
    // here never reached cards injected client-side (dynamic homepage
    // sections don't execute snippet scripts), and running both would
    // double-advance on hover. Kept as a no-op so initAll()/callers survive.
  }

  // Wishlist
  var WK = 'menahub_wishlist';
  function getWL() { try { var w = localStorage.getItem(WK); return w ? JSON.parse(w) : []; } catch(e) { return []; } }
  function saveWL(w) { try { localStorage.setItem(WK, JSON.stringify(w)); } catch(e) {} }

  function initWishlist(scope) {
    var root = scope || document;
    var btns = root.querySelectorAll('.mh-wishlist-btn');
    var wl = getWL();
    btns.forEach(function(btn) {
      if (btn.dataset.wlInit === '1') return;
      btn.dataset.wlInit = '1';
      var pid = btn.dataset.productId;
      if (wl.indexOf(pid) > -1) btn.classList.add('active');
      btn.addEventListener('click', function(e) {
        e.preventDefault(); e.stopPropagation();
        var list = getWL();
        var i = list.indexOf(pid);
        if (i > -1) { list.splice(i, 1); btn.classList.remove('active'); }
        else { list.push(pid); btn.classList.add('active'); btn.style.transform = 'scale(1.3)'; setTimeout(function(){ btn.style.transform = ''; }, 200); }
        saveWL(list);
      });
    });
  }

  // Quick add to cart (AJAX)
  function initQuickAdd(scope) {
    var root = scope || document;
    var forms = root.querySelectorAll('.mh-quick-add-form');
    forms.forEach(function(form) {
      if (form.dataset.qaInit === '1') return;
      form.dataset.qaInit = '1';
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var id = form.querySelector('input[name="id"]').value;
        var btn = form.querySelector('.mh-plus-icon');
        if (!id || (btn && btn.disabled)) return;
        if (btn) btn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(id), quantity: 1 }] })
        })
        .then(function(r) { return r.json(); })
        .then(function() {
          if (btn) {
            btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"></polyline></svg>';
            setTimeout(function() {
              btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>';
              btn.disabled = false;
            }, 1500);
          }
          // Update cart count
          fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
            document.querySelectorAll('.cart-count, [data-cart-count]').forEach(function(el){ el.textContent = cart.item_count; });
          });
        })
        .catch(function() {
          if (btn) btn.disabled = false;
        });
      });
    });
  }

  // PayLater badge: swap the icon+text pill for the admin-uploaded logo.
  // The logo is fetched once per page (cached on the IIFE scope) and applied
  // to any card badge, including infinite-scroll-loaded ones.
  var PL_LOGO = null; // null = not fetched, '' = no logo set, else URL
  function applyPlLogo(scope) {
    if (!PL_LOGO) return;
    var root = scope || document;
    root.querySelectorAll('.mh-pl-card-badge[data-pl-badge]:not([data-pl-logo])').forEach(function(b) {
      b.dataset.plLogo = '1';
      b.classList.add('has-logo');
      var im = document.createElement('img');
      im.className = 'mh-pl-card-logo'; im.src = PL_LOGO; im.alt = 'PayLater';
      // EAGER (not lazy): these badges sit on cards inside off-screen carousels,
      // where a lazy logo never loads and the chip renders empty/invisible.
      im.loading = 'eager';
      // If the logo image fails, fall back to a plain "PayLater" text pill
      // instead of an empty white chip.
      im.onerror = function () {
        b.classList.remove('has-logo');
        b.replaceChildren(document.createTextNode('PayLater'));
      };
      b.replaceChildren(im);
    });
  }
  function initPlBadges(scope) {
    if (!document.querySelector('.mh-pl-card-badge')) return;
    if (PL_LOGO === null) {
      // Paint INSTANTLY from the cached logo so a slow (mobile) connection never
      // flashes the pink "PayLater" text pill before the fetch lands. The cache
      // is shared with the offer/paylater grid script (same 'mh_pl_logo' key), so
      // once any page has fetched once, every later page swaps with no network.
      try { var cached = localStorage.getItem('mh_pl_logo'); if (cached) { PL_LOGO = cached; applyPlLogo(); } } catch (e) {}
      if (PL_LOGO === null) PL_LOGO = ''; // mark as fetching so we only fetch once
      fetch('https://admin.menahub.com/api/bnpl_banners.php')
        .then(function(r){ return r.json(); })
        .then(function(d){ var u = (d && d.logo) ? d.logo : ''; PL_LOGO = u; try { if (u) localStorage.setItem('mh_pl_logo', u); else localStorage.removeItem('mh_pl_logo'); } catch (e) {} applyPlLogo(); })
        .catch(function(){});
    } else {
      applyPlLogo(scope);
    }
  }

  // ── PayLater badge placement: top → middle → bottom on the LEFT edge,
  // dodging the top-left Deal/Hot Deal badges + countdown timer. The other
  // badges hydrate asynchronously, so we measure how far down the left-edge
  // "cluster" reaches and drop the PayLater badge into the first free slot.
  function positionPlBadge(badge) {
    // Vertically centred on the LEFT edge so it always clears the top-left
    // Deal / Limited-Stock badges + countdown timer (never overlaps them).
    badge.classList.remove('mh-pl--top', 'mh-pl--bottom');
    badge.classList.add('mh-pl--middle');
  }
  function positionPlBadges(scope) {
    (scope || document).querySelectorAll('.mh-pl-card-badge').forEach(positionPlBadge);
  }
  function schedulePlPositioning(scope) {
    positionPlBadges(scope);
    // Re-run as the async Deal/Hot Deal badges + countdown timer hydrate.
    [350, 900, 1700].forEach(function (ms) {
      setTimeout(function () { positionPlBadges(scope); }, ms);
    });
  }

  function initAll(scope) {
    initCarousels(scope);
    initWishlist(scope);
    initQuickAdd(scope);
    initPlBadges(scope);
    schedulePlPositioning(scope);
  }

  // Expose for infinite scroll
  window.mhInitCarousels = function(scope) { initAll(scope); };

  // Homepage carousels (Beat the Heat / New Arrivals etc.) inject card HTML
  // asynchronously and fire this event. Without re-running initAll on the new
  // container, those cards never get the PayLater LOGO applied — they stay on
  // the purple/pink fallback pill. Re-init the injected scope here.
  window.addEventListener('mh:product-cards-injected', function (e) {
    var scope = (e && e.detail && e.detail.container) ? e.detail.container : document;
    initAll(scope);
  });

  // Init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initAll(); });
  } else {
    initAll();
  }

  // Re-place PayLater badges after full load (badges/images settled) and on
  // resize (image height + breakpoint can change which slot is free).
  window.addEventListener('load', function () { positionPlBadges(); });
  var _plRzT = null;
  window.addEventListener('resize', function () {
    clearTimeout(_plRzT);
    _plRzT = setTimeout(function () { positionPlBadges(); }, 200);
  });
  // The Deal/Hot Deal badges + countdown timer hydrate asynchronously (and can
  // be slow on heavy pages), so watch for them and re-place once they appear.
  if (typeof MutationObserver !== 'undefined') {
    var _plPend = false;
    new MutationObserver(function () {
      if (_plPend) return;
      _plPend = true;
      setTimeout(function () { _plPend = false; positionPlBadges(); }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
